import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {compose} from 'redux';
import {v4 as uuidV4} from 'uuid';
import QuickFilters from 'common/search-filters-controls';
import WithSearchControls from 'common/search-controls/with-search-controls';
import SearchInput from 'common/search-controls/location-input';
import SearchDateTimePickers from 'common/search-controls/date-time-pickers';
import SearchActions from 'common/search-controls/submit-cancel-actions';
import SpotListHeading from '../spot-list-heading';
import SearchControlsInfo from 'common/search-controls/search-controls-info';
import SearchTransientInOutFilter from 'pages/search-transient-event-monthly/components/search-transient-inout-filter';

class SpotListSearchControls extends Component {
    static propTypes = {
        isMobile: PropTypes.bool,
        isAdmin: PropTypes.bool.isRequired,
        timezone: PropTypes.string.isRequired,
        isMonthly: PropTypes.bool,
        starts: PropTypes.string,
        ends: PropTypes.string,
        searchString: PropTypes.string,
        searchBounds: PropTypes.shape({
            swLat: PropTypes.number,
            swLng: PropTypes.number,
            neLat: PropTypes.number,
            neLng: PropTypes.number,
        }),
        isSearching: PropTypes.bool,
        isValidStart: PropTypes.bool,
        onInputChange: PropTypes.func.isRequired,
        onDateTimeChange: PropTypes.func,
        onSubmit: PropTypes.func.isRequired,
        onSearchClick: PropTypes.func,
        numSpots: PropTypes.number.isRequired,
        searchType: PropTypes.string.isRequired,
        breadcrumbs: PropTypes.object,
        showNoSpotsFound: PropTypes.bool,
        onToggleEventList: PropTypes.func,
        appleMapsPartner: PropTypes.bool.isRequired,
    };
    state = {
        inputKey: uuidV4(),
        dateTimeKey: uuidV4(),
        showActions: false,
    };

    componentDidUpdate(prevProps) {
        // If starts and ends updated elsewhere - like EditTimesModal. Need them to change here as well.
        if (
            prevProps.starts !== this.props.starts ||
            prevProps.ends !== this.props.ends
        ) {
            this.setState({dateTimeKey: uuidV4()}); // eslint-disable-line
        }
    }

    _onActionsToggle = isShowing => {
        this.setState({
            showActions: isShowing,
        });
    };

    _onSuggestSelect = currentSearch => {
        // update search input to match with selected suggestion address
        this.props.onInputChange(currentSearch);

        this.setState({
            showActions: true,
        });
    };

    _onDateTimeChange = data => {
        this.setState({
            showActions: true,
        });

        this.props.onDateTimeChange(data);
    };

    _onSearchClick = () => {
        this.setState({
            showActions: false,
        });

        this.props.onSearchClick();
    };

    _onCancelClick = () => {
        this.setState({
            inputKey: uuidV4(),
            dateTimeKey: uuidV4(),
            showActions: false,
        });
    };

    render() {
        const {
            isMobile,
            isAdmin,
            timezone,
            isMonthly,
            searchString,
            starts,
            ends,
            searchBounds,
            isSearching,
            isValidStart,
            onInputChange,
            onSubmit,
            searchType,
            breadcrumbs,
            showNoSpotsFound,
            numSpots,
            onToggleEventList,
            appleMapsPartner,
        } = this.props;
        const {inputKey, dateTimeKey, showActions} = this.state;

        return (
            <div className="SpotListSearchControls">
                <SearchControlsInfo
                    isMobile={isMobile}
                    searchType={searchType}
                    breadcrumbs={breadcrumbs}
                />
                <SpotListHeading
                    showEventsLink={!isMobile}
                    onShowInfoClick={this._onShowInfoClick}
                    onToggleEventList={onToggleEventList}
                />
                <div className="SpotListSearchControls-controls">
                    {(!appleMapsPartner || isMonthly) && (
                        <SearchInput
                            key={inputKey}
                            isMonthly={isMonthly}
                            isSearching={isSearching}
                            searchString={searchString}
                            searchBounds={searchBounds}
                            onSuggestSelect={this._onSuggestSelect}
                            onChange={onInputChange}
                            onSubmit={onSubmit}
                        />
                    )}
                    <SearchDateTimePickers
                        key={dateTimeKey}
                        isAdmin={isAdmin}
                        timezone={timezone}
                        isMonthly={isMonthly}
                        starts={starts}
                        ends={ends}
                        onChange={this._onDateTimeChange}
                    />
                    {showActions && (
                        <SearchActions
                            addKeyListeners={!isMobile}
                            showCancel
                            searchButtonText="Update Search"
                            isSearching={isSearching}
                            isValidStart={isValidStart}
                            onSearchClick={this._onSearchClick}
                            onCancelClick={this._onCancelClick}
                        />
                    )}
                </div>
                {numSpots > 0 && !showNoSpotsFound && !showActions && (
                    <QuickFilters
                        showReservationTypes={isMonthly}
                        visibleSlugs={['self-park']}
                        extraFilterSlot={
                            isMonthly ? null : <SearchTransientInOutFilter />
                        }
                    />
                )}
            </div>
        );
    }
}

const mapStateToProps = ({
    filters: {numActive},
    search: {
        data: {breadcrumbs, searchType, showNoSpotsFound},
    },
    searchRequest,
}) => {
    const appleMapsPartner =
        searchRequest.partner === 'apple' ||
        searchRequest.partner === 'appleTest';

    return {
        breadcrumbs,
        numActiveFilters: numActive,
        searchType,
        showNoSpotsFound,
        appleMapsPartner,
    };
};

const mapDispatchToProps = {};

const enhance = compose(
    WithSearchControls,
    connect(mapStateToProps, mapDispatchToProps)
);

export default enhance(SpotListSearchControls);
